export default __webpack_public_path__ + "static/media/VoP.d7c05594.png";